import {
  FeatureGateEnvironment,
  Identifiers
} from '@atlassian/feature-gate-js-client';
import { FeatureGatesInitialization } from '@atlassian/feature-gates-react';
import React, { PropsWithChildren } from 'react';
import {
  ENV_DEV,
  ENV_PRODUCTION,
  ENV_STAGING,
  Environment,
  Storage
} from '../';

type EnvConfig = {
  apiKey: string;
  environment: FeatureGateEnvironment;
};

// WAC Statsig api keys - https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/#statsig-only-supported
const getEnvironmentConfig = (): EnvConfig => {
  const environment = Environment.getEnvironment();
  switch (environment) {
    case ENV_PRODUCTION:
      return {
        apiKey: '4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f',
        environment: FeatureGateEnvironment.Production
      };
    case ENV_STAGING:
      return {
        apiKey: 'ff9c70b0-ab7e-4abc-be4f-53f9c3fd37d6',
        environment: FeatureGateEnvironment.Staging
      };
    case ENV_DEV:
    default:
      return {
        apiKey: 'ab9944a4-9eb2-482b-b997-36f41f3a1edf',
        environment: FeatureGateEnvironment.Development
      };
  }
};

export type BxpKitFeatureGatesInitializationProps = PropsWithChildren<{
  identifiers: Identifiers;
}>;

/**
 * Initializes the feature gate client
 */
export const BxpKitFeatureGatesInitialization = ({
  identifiers,
  children
}: BxpKitFeatureGatesInitializationProps) => {
  const envConfig: EnvConfig = getEnvironmentConfig();

  const analyticsAnonymousId = (
    Storage.getCookie('ajs_anonymous_id') ?? ''
  ).replace(/\"/g, '');

  return (
    <FeatureGatesInitialization
      options={{
        ...envConfig,
        targetApp: 'bxp-web-platform_web',
        eventLoggingApi: 'https://xp.atlassian.com/v1/'
      }}
      identifiers={{
        analyticsAnonymousId,
        ...identifiers
      }}
    >
      {children}
    </FeatureGatesInitialization>
  );
};
